import { format, parseISO } from "date-fns";
export const activityUserColums = [
  {
    name: "Evento",
    selector: (row) =>
      `${getUserName(row)}  ${translateEvent(row?.event)}  ${translateAuditable(
        row
      )} #${row?.auditable_id}`,
    sortable: true,
    center: false,
  },
  {
    name: "Tipo",
    cell: (row) => (
      <div className="d-flex  align-items-center gap-3">
        <span className={`badge badge-light-${getColorBadge(row)}`}>
          {translateEventName(row?.event)}
        </span>
      </div>
    ),

    sortable: false,
    center: true,
  },
  {
    name: "Fecha",
    selector: (row) => `${getDate(row)}`,

    sortable: true,
    center: true,
  },
];

const getUserName = (row) => {
  if (row?.user_audit)
    return `${row?.user_audit?.first_name} ${row?.user_audit?.last_name}`;
  else return "El sistema";
};
const getDate = (row) => {
  let date = format(parseISO(row?.created_at), "yyyy-MM-dd H:mm a");
  return date;
};
const translateEvent = (row) => {
  switch (row) {
    case "created":
      return "creó";
    case "updated":
      return "actualizó";
    case "deleted":
      return "eliminó";
    case "retrieved":
      return "visualizó";
    case "restored":
      return "restauró";
    case "exported":
      return "exportó";
    default:
      return "";
  }
};
const translateEventName = (row) => {
  switch (row) {
    case "created":
      return "CREACION";
    case "updated":
      return "ACTUALIZACON";
    case "deleted":
      return "ELIMINACION";
    case "retrieved":
      return "VISUALIZACION";
    case "restored":
      return "RESTAURACION";
    case "updated_permissions":
      return "ACTUALIZACION";
    case "exported":
      return "EXPORTACION";
    default:
      return "";
  }
};

const translateAuditable = (row) => {
  switch (row.auditable_type) {
    case "user":
      return `El Usuario ${row?.user?.first_name} ${row?.user?.last_name}`;
    case "contact":
      return `El Contacto ${row?.auditable?.first_name} ${row?.auditable?.last_name}`;
    case "contact_comunication_data":
      return `Los datos de contacto de ${row?.auditable?.contact?.first_name} ${row?.auditable?.contact?.last_name}`;
    case "contact_personal_data":
      return `Los datos personales de ${row?.auditable?.contact?.first_name} ${row?.auditable?.contact?.last_name}`;
    case "contact_social_data":
      return `Los datos sociales de  ${row?.contact?.auditable?.first_name} ${row?.auditable?.contact?.last_name}`;
    case "contact_has_entity":
      return `La entidad ${row?.entity?.name} del contacto ${row?.contact?.first_name} ${row?.contact?.last_name}`;
    case "contact_has_comission":
      return `La comision ${row?.auditable?.name} del contacto ${row?.contact?.first_name} ${row?.contact?.last_name}`;
    case "entity":
      return `La entidad ${row?.auditable?.name}`;
    case "area":
      return `El area ${row?.auditable?.name} `;
    case "asesor_charge":
      return `El cargo ${row?.auditable?.name} `;
    case "block":
      return `El bloque ${row?.auditable?.name} `;
    case "contact_charge":
      return `El cargo ${row?.auditable?.name} `;
    case "district":
      return `El distrito ${row?.auditable?.name} `;
    case "jurisdiction":
      return `La jurisdiccion ${row?.auditable?.name} `;
    case "politic_space":
      return `El espacio politico ${row?.auditable?.name} `;
    case "asesor":
      return `El asesor ${row?.auditable?.first_name} ${row?.auditable?.last_name} `;
    case "comission":
      return `La comision ${row?.auditable?.name}`;
    case "file":
      return `El archivo ${row?.auditable?.name}`;
    case "link":
      return `El enlace ${row?.auditable?.url}`;
    case "note":
      return `La nota ${row?.auditable?.content}`;
    default:
      return `El ${row?.auditable_type} ${row?.auditable?.name}`;
  }
};

const getColorBadge = (row) => {
  switch (row?.event) {
    case "created":
      return "success";
    case "updated":
      return "warning";
    case "deleted":
      return "danger";
    case "retrieved":
      return "info";
    default:
      return "";
  }
};
